import React, { useState, useMemo } from 'react'
import ReactDOM from 'react-dom'
import { func } from 'prop-types'
import Dropdown from '../ui/dropdown/Dropdown'
import List from '../ui/list/List'
import Icon from '../ui/icon/Icon'
import Button from '../ui/button/Button'
import { ContentView, MobileContent } from './partials'
import { useWindowDimensions } from '../../providers/WindowDimensionsProvider'
import { SORT } from './constants'

const SORT_OPTIONS = [
  { name: 'Date: Newest first', value: 'date_desc' },
  { name: 'Date: Oldest first', value: 'date_asc' }
]

const SortOptions = ({ requestResults }) => {
  const { width = window.innerWidth } = useWindowDimensions() || {}
  const isMobile = useMemo(() => width <= 768, [width])
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const sortResults = (_e, item) => {
    requestResults(item.value)
  }

  return !isMobile ? (
    <Dropdown
      innerLabelHTML
      label={<><Icon svg='sort' /><span>Sort</span></>}
    >
      {() => (
        <div className='ad-filter' style={{ right: 0 }}>
          <ContentView
            renderFilter={
              <List onClick={sortResults} isInnerHtml items={SORT_OPTIONS} />
            }
          />
        </div>
      )}
    </Dropdown>
  )
    : <>
      <div className='ad-dropdown'>
        <Button
          onClick={() => setMobileMenuOpen(open => !open)}
        >
          <><Icon svg='sort' /><span>Sort</span></>
        </Button>
      </div>
      {
        mobileMenuOpen && ReactDOM.createPortal(
          <MobileContent
            containerClasses='ad-filter'
            headerBarProps={{ cancelCallback: () => setMobileMenuOpen(false) }}
            headerProps={{ item: SORT, searchType: 'article-archive' }}
            itemLabel='Mobile label'
            contentViewProps={{

              filteredData: SORT_OPTIONS,
              renderFilter: <List onClick={sortResults} isInnerHtml items={SORT_OPTIONS} />
            }}
          />,
          document.body
        )
      }
    </>
}

SortOptions.propTypes = {
  requestResults: func
}

export default SortOptions
